var React = require('react');

function Arrow2Right (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#010101","d":"M47.863,23.477c0.015-0.027,0.038-0.047,0.05-0.075C47.967,23.279,48,23.144,48,23s-0.033-0.279-0.087-0.402\r\n\tc-0.012-0.028-0.036-0.048-0.05-0.075c-0.051-0.093-0.109-0.18-0.186-0.251c-0.007-0.007-0.01-0.017-0.017-0.023l-25-22\r\n\tc-0.413-0.364-1.045-0.324-1.411,0.091c-0.364,0.414-0.324,1.046,0.091,1.411L44.35,22H1c-0.553,0-1,0.447-1,1s0.447,1,1,1h43.35\r\n\tL21.34,44.249c-0.415,0.365-0.455,0.997-0.091,1.411C21.447,45.886,21.723,46,22,46c0.235,0,0.471-0.082,0.66-0.249l25-22\r\n\tc0.007-0.007,0.01-0.017,0.017-0.023C47.754,23.656,47.811,23.569,47.863,23.477z"}));
}

Arrow2Right.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"48px","height":"48px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48","xmlSpace":"preserve"};

module.exports = Arrow2Right;

Arrow2Right.default = Arrow2Right;
